// src/components/common/Form/SlideResults.js
import React from "react";

const SlideResults = ({ data, isActive, formData, options, onGenerateWorkout, loading }) => (
  <div className={`carousel-item c-item ${isActive ? "active" : ""}`}>
    <h1 className="display-2 fw-bolder mb-5 hero-title">
      {data.titleBefore} <span className="text-color">{data.titleRed}</span>
      {data.titleAfter}
    </h1>
    <div className="selected-choices capitalize-text">
      <p className="results-spacing">
        {data.selection.sex}: {options.sex[formData.sex]}
      </p>
      <p className="results-spacing">
        {data.selection.age}: {formData.ageRange}
      </p>
      <p className="results-spacing">
        {data.selection.fitnessGoal}: {options.fitnessGoal[formData.fitnessGoal]}
      </p>
      <p className="results-spacing">
        {data.selection.experience}: {options.experience[formData.experience]}
      </p>
      <p className="results-spacing">
        {data.selection.workout}: {options.workout[formData.workout]}
      </p>
      <p className="results-spacing">
        {data.selection.time}: {formData.time} min
      </p>
      <p className="results-spacing">
        {data.selection.intensity}: {options.intensity[formData.intensity]}
      </p>
    </div>
    <div className="generate-workout-container">
      <span className="generate-workout-line"></span>
      <button type="button" className="generate-workout-btn" onClick={onGenerateWorkout} disabled={!!loading} aria-busy={!!loading}>
        {loading ? data.loadingLabel ?? "Generating..." : data.button}
      </button>

      <span className="generate-workout-line"></span>
    </div>
  </div>
);

export default SlideResults;
